import { useEffect, useState, useCallback } from "react";
import api from "../services/api";
import { useCompanies } from "./companies";

const useAutopilotInsightsCte = () => {
  const { empresaId } = useCompanies();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async (force) => {
    let mounted = true;
    setLoading(true);
    setError(null);
    try {
      const params = force ? { force: true } : {};
      if (empresaId) params.embarcadorId = empresaId;
      const response = await api.get("/autopilot/insights/cte", { params });
      if (mounted) setData(response.data);
    } catch (err) {
      if (mounted) setError("Não foi possível carregar os insights de CTe.");
    } finally {
      if (mounted) setLoading(false);
    }
    return () => { mounted = false; };
  }, [empresaId]);

  useEffect(() => { load(false); }, [load]);

  return { loading, data, error, refresh: () => load(true) };
};

export default useAutopilotInsightsCte;
